import Vue from 'vue';
import store from '@/store';
import { errorLog } from '@/utils/logger';

function Zendesk() {
  const { $zendesk } = Vue.prototype;

  const loaded = new Promise(resolve => $zendesk.$on('loaded', resolve));

  const init = async currWorkspace => {
    await loaded;

    try {
      const { profileType, clinic, email } = currWorkspace,
        name = store.getters['dashboard/currFullName'];

      $zendesk.identify({
        name,
        email,
      });
      $zendesk.zE('webWidget', 'chat:addTags', ['perfil', profileType]);
      $zendesk.zE('webWidget', 'chat:addTags', ['cliente', clinic.name]);
    } catch (err) {
      errorLog(err);
    }
  };

  const addServiceProfileTags = async ({ redeConexa, saas, whiteLabel }) => {
    await loaded;

    const tags = [
      ['SAAS', saas],
      ['Rede Conexa', redeConexa],
      ['Whitelabel', whiteLabel],
    ];
    tags.forEach(([profileName, activeFlag]) => {
      if (!activeFlag) return;

      $zendesk.zE('webWidget', 'chat:addTags', [profileName, activeFlag]);
    });
  };

  return { loaded, init, addServiceProfileTags };
}

export default Zendesk;
